import superagent from 'superagent'

export const markerTypes105Set = markerTypes => ({
  type: 'MARKER_TYPES_105_SET',
  payload: markerTypes
})

export const markerTypes105FetchRequest = () => (dispatch, getState, token) => {
  return new Promise(resolve => {
    superagent
      .get(`${__API_URI_2__}/markertype/get?activity=255&folder=small105`)
      .set('Authorization', `Bearer ${token}`)
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (!res) return resolve(null)
        if (err) {
          if (err.status == 401) {
            return resolve(err.status)
          }
          return resolve(null)
        }
        dispatch(markerTypes105Set(res.body))
        resolve(res.body)
      })
  })
}
